import api from '@utils/api';

export const assignPlaceToUser = async (data) => {
  try {
    const response = await api.post('/user_place/', data);
    return response.data;
  } catch (error) {
    console.error('Error assigning place to user:', error);
    throw error;
  }
};
